export const LAYOUT_DEF = {
    UPCOMING: "upcoming",
    WHITELIST_OPEN: "whitelist-open",
    WHITELIST_CLOSE: "whitelist-close",
    WHITELIST_APPLIED: "whitelist-applied",
    WHITELIST_WIN: "whitelist-win",
    WHITELIST_FAIL: "whitelist-fail",
    TOKEN_PURCHASE: "token-purchase",
    TOKEN_PURCHASE_CLOSE: "token-purchase-close",
    MY_ALLOCATION: "my-allocation",
};